<template lang="html">

  <section class="icons">
    <div class="row">
      <div class="col-lg-12 grid-margin">
        <div class="card">
          <div class="card-body">
            <div class="icons-list row">
              <div class="col-sm-6 col-md-4 col-lg-3" v-for="icon in icons" :key="icon.id">
                <i :class="'mdi mdi-' + icon.name"></i> mdi mdi-{{icon.name}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

</template>

<script lang="js">
import axios from 'axios'

export default {
  name: 'icons',
  data () {
    return {
      icons: null
    }
  },
  mounted () {
    axios
      .get('https://raw.githubusercontent.com/Templarian/MaterialDesign/master/meta.json')
      .then(response => (this.icons = response.data))
  }
}
</script>

<style scoped lang="scss">
.icons {

}
</style>



// WEBPACK FOOTER //
// src/views/ui-components/icons.vue